import { useState, useEffect, useCallback } from "react";
import { createTicketsApi, type TicketDetailResponse, type Comment } from "../api/tickets";

export function useTicketDetail(token: string, workspaceId: string | null, ticketId: string) {
  const [ticket, setTicket] = useState<TicketDetailResponse | null>(null);
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!token || !workspaceId || !ticketId) return;
    setLoading(true);
    setError(null);
    try {
      const api = createTicketsApi(token, workspaceId);
      const ticketResult = await api.get(ticketId);
      setTicket(ticketResult);
      try {
        const commentsResult = await api.comments(ticketResult.id);
        setComments(commentsResult.comments ?? []);
      } catch {
        setComments([]);
      }
    } catch (err) {
      setTicket(null);
      setError(err instanceof Error ? err.message : "Failed to load ticket");
    } finally {
      setLoading(false);
    }
  }, [token, workspaceId, ticketId]);

  useEffect(() => { load(); }, [load]);

  return { ticket, comments, loading, error, refresh: load };
}
